import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog.js';
import { MemoriesPanel } from '@/components/panels/MemoriesPanel.js';

interface MemoriesModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MemoriesModal({ open, onOpenChange }: MemoriesModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl h-[80vh] p-0 gap-0 flex flex-col">
        <DialogHeader className="px-6 py-4 border-b">
          <DialogTitle>Memories</DialogTitle>
          <DialogDescription>
            Quick facts and preferences I'll use to personalize our conversations
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-hidden">
          <MemoriesPanel hideHeader />
        </div>
      </DialogContent>
    </Dialog>
  );
}
